import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function SafetyAndCta() {
  const { t } = useTranslation();
  const points = [1, 2, 3, 4];

  return (
    <>
      <section id="safety" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="flex flex-col justify-center p-8 md:p-10">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-shield-star-line text-2xl" />
              </span>
              <h2 className="mt-5 text-2xl font-bold text-foreground-950 md:text-3xl">{t('safety.title')}</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('safety.copy')}</p>

              <ul className="mt-6 space-y-3">
                {points.map((n) => (
                  <li key={n} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 items-center justify-center text-accent-600">
                      <i className="ri-checkbox-circle-line text-base" />
                    </span>
                    {t(`safety.point${n}`)}
                  </li>
                ))}
              </ul>

              <a
                href="#safety"
                className="mt-7 inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
              >
                {t('safety.cta')}
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
            <div className="relative min-h-[300px] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20a%20shield%20and%20padlock%20illustration%20on%20a%20clean%20warm%20beige%20background%2C%20soft%20sage%20green%20accents%2C%20minimal%20editorial%20style%2C%20gentle%20natural%20lighting%2C%20calm%20harmonious%20composition&width=900&height=700&seq=safety-01&orientation=landscape"
                alt="USFans safety center"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-primary-500">
        <div className="mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-20">
          <h2 className="text-2xl font-bold text-background-50 md:text-3xl">{t('final.title')}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-primary-50 md:text-base">
            {t('final.copy')}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/article/what-is-usfans-spreadsheet"
              className="flex w-full items-center justify-center gap-2 rounded-md bg-background-50 px-7 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 whitespace-nowrap sm:w-auto"
            >
              {t('final.cta')}
              <i className="ri-arrow-right-line text-sm" />
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex w-full items-center justify-center gap-2 rounded-md border border-background-50/40 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap sm:w-auto"
            >
              {t('final.secondary')}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}